document.addEventListener('change', function (e) {
  var wrap = e.target.closest('[data-gift-section]');
  if (!wrap) return;

  var checkbox = wrap.querySelector('[data-gift-checkbox]');
  var note = wrap.querySelector('[data-gift-note]');
  if (!checkbox || !note) return;

  // Clear the message when the box is unticked
  if (e.target === checkbox && !checkbox.checked) note.value = '';

  // Empty values remove the attribute from the order
  var attributes = checkbox.checked
    ? { 'Gift wrapping': 'Yes', 'Gift note': note.value }
    : { 'Gift wrapping': '', 'Gift note': '' };

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attributes }),
    keepalive: true
  });
});
